import { useState } from 'react';
import axios from 'axios';
import { FilePdf } from '@phosphor-icons/react';

const API = process.env.REACT_APP_BACKEND_URL;
export const PAPERS_PDF_PATH = '/downloads/the-anti-salesforce-papers.pdf';

// Lead-magnet box: direct PDF download + optional "email me a copy".
export const BlogPdfBox = () => {
  const [email, setEmail] = useState('');
  const [state, setState] = useState('idle');
  const [error, setError] = useState('');

  const sendEmail = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setState('sending');
    setError('');
    try {
      await axios.post(`${API}/api/blog/email-pdf`, { email: email.trim() });
      setState('sent');
    } catch (err) {
      setState('idle');
      setError(err.response?.data?.detail || "Couldn't send — use the download button instead");
    }
  };

  return (
    <div className="rounded-lg border-2 border-[#0B5394] bg-blue-50/50 p-6 sm:p-8" data-testid="blog-pdf-box">
      <div className="flex items-start gap-4">
        <div className="hidden sm:flex w-11 h-11 rounded bg-[#0B5394] items-center justify-center shrink-0">
          <FilePdf size={24} weight="bold" className="text-white" />
        </div>
        <div className="flex-1">
          <p className="text-lg font-black text-slate-900 leading-snug mb-1">
            Want the full essay series as one printable guide?
          </p>
          <p className="text-sm text-slate-500 mb-4">
            <strong>The Anti-Salesforce Papers</strong> &mdash; all eight essays in a single PDF. Free, no email required.
          </p>
          <div className="flex flex-wrap items-center gap-3">
            <a
              href={PAPERS_PDF_PATH}
              download
              className="text-sm font-bold text-white bg-[#0B5394] hover:bg-[#094276] px-5 py-2.5 rounded"
              data-testid="blog-pdf-download-btn"
            >
              Download the free PDF
            </a>
            <span className="text-xs font-bold text-slate-400 uppercase">or</span>
            {state === 'sent' ? (
              <p className="text-sm font-bold text-green-700" data-testid="blog-pdf-email-success">
                On its way — check your inbox.
              </p>
            ) : (
              <form onSubmit={sendEmail} className="flex flex-wrap items-center gap-2">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@company.com"
                  className="text-sm border border-slate-300 rounded px-3 py-2.5 w-52 focus:outline-none focus:border-[#0B5394] bg-white"
                  data-testid="blog-pdf-email-input"
                />
                <button
                  type="submit"
                  disabled={state === 'sending'}
                  className="text-sm font-bold text-[#0B5394] border border-[#0B5394] hover:bg-blue-100 px-4 py-2.5 rounded disabled:opacity-50"
                  data-testid="blog-pdf-email-btn"
                >
                  {state === 'sending' ? 'Sending…' : 'Email me a copy'}
                </button>
              </form>
            )}
          </div>
          {error && (
            <p className="text-xs text-red-600 mt-2" data-testid="blog-pdf-email-error">{error}</p>
          )}
        </div>
      </div>
    </div>
  );
};
